import { ISetNameParams } from '../types/actionParams';
import { IEmptyResult } from '../types/IResponse';
import { Request } from './Request';

export class SetProjectNameRequest extends Request<ISetNameParams, IEmptyResult> {
  constructor(id: string, name: string) {
    super('setProjectName', {
      id: id,
      name: name
    });
  }
}
